export default __webpack_public_path__ + "static/media/green3.ff8c7bfd.png";